export default __webpack_public_path__ + "static/media/85t.d0e59f07.jpg";